import type { LobbyState } from './lobbyStore.types';

export const connectionSlice: Pick<
  LobbyState,
  | 'isOnline'
  | 'connectionLatency'
  | 'lobbyId'
  | 'reconnectFailed'
  | 'setOnline'
  | 'setConnectionLatency'
  | 'setLobbyId'
  | 'setReconnectFailed'
> = {
  isOnline: false,
  connectionLatency: null,
  lobbyId: null,
  reconnectFailed: false,

  setOnline: (isOnline: boolean) =>
    isOnline ? { isOnline, reconnectFailed: false } : { isOnline },
  setConnectionLatency: (latency: number | null) => ({ connectionLatency: latency }),
  setLobbyId: (lobbyId: string | null) => ({ lobbyId }),
  setReconnectFailed: (failed: boolean) => ({ reconnectFailed: failed }),
};
